import logo from "./Images/Illustration/download (11).png";
import foot1 from "./Images/Illustration/download (2).jpg";
import foot2 from "./Images/Illustration/foot2.jpg";
import foot3 from "./Images/Illustration/foot3.jpg";
const Footer=()=>{
    return(
        <section class='container-fluid footer text-white pt-5'>
        <div class='row'>
            <div class='col-12 col-md-4 text-center'>
            <img src={logo} alt="Image Not Found"/>
            <p>sed do eiusmod tempor incididunt ut labore et dolore magna as aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.</p>
            <h3>HEAD OFFICE</h3>
            <ul>
                <li>125 Big fella St. Road, New York, Hi 5654775</li>
                <li>Phone: 326487652</li>
                <li>Email: example@mail.com</li>
                <li>Office Time: 9AM- 4PM</li>
            </ul>
            </div>
            <div class='col-12 col-md-4'>
            <h3>Quick Link</h3>
            <ul>
                <li>About us &nbsp; &nbsp; &nbsp; &nbsp;Testimonials</li>
                <li>Our Services &nbsp; &nbsp; &nbsp; Privacy Policy</li>
                <li>Case Studies &nbsp; &nbsp; &nbsp; Latest News</li>
            </ul>
            <h3>NEWSLETTER</h3>
            <div class="input-group">
    <input type="text" class="form-control" placeholder="Email Address" aria-label="Input group example" aria-describedby="btnGroupAddon"/>
    <div class="input-group-text" id="btnGroupAddon">Submit</div>
  </div>

            </div>
            <div class='col-12 col-md-4 post'>
                <h3>Recent Post</h3>
            <ul>
                <li><div class='row'>
                    <div class='col-3'><img src={foot1}/></div>
                    <div class='col-9'><h4>Revealed: How to set goals for you and your team</h4>
                <p>Posted on: Jan 12, 2019</p></div>
                    </div></li>
                    <li><div class='row'>
                    <div class='col-3'><img src={foot2}/></div>
                    <div class='col-9'><h4>Revealed: How to set goals for you and your team</h4>
                <p>Posted on: Jan 12, 2019</p></div>
                    </div></li>
                    <li><div class='row'>
                    <div class='col-3'><img src={foot3}/></div>
                    <div class='col-9'><h4>apartment in the sky love three boys of his own.</h4>
                <p>Posted on: Jan 12, 2019</p></div>
                    </div></li>
               
            </ul>
            </div>
        </div>
    </section>
       )
    };
export default Footer;
